export default {
    c: "Checking",
    s: "Savings"
};



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/accountTypeOptions.ts